import React, { useState, useEffect } from 'react';

import { getJWT, removeJWT, jwtIsValid } from "./storage.js";

import Login from './Login.js'
import Admin from './Admin.js'

function Beekeeper() {
  const [jwt, setJwt] = useState("");

  useEffect(() => {
    let jwt = getJWT()
    setJwt(jwt);
  }, []);

  const handleLogin = () => {
    let jwt = getJWT()
    setJwt(jwt);
  };

  const handleLogout = () => {
    removeJWT();
    setJwt("");
  };

  if (jwt !== "" && !jwtIsValid()) {
    setJwt("")
  }

  return (
    <div className="container block is-max-desktop">
      {jwt ? (
        <Admin handleLogout={handleLogout} />
      ) : (
        <Login handleLogin={handleLogin} />
      )}
    </div>
  )
}

export default Beekeeper;
